import { render, staticRenderFns } from "./ReceivablesAggregations.vue?vue&type=template&id=81c07db6&"
import script from "./ReceivablesAggregations.vue?vue&type=script&lang=js&"
export * from "./ReceivablesAggregations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports